import { updateDocumentCategories } from '../../../actions'
import { normalizeCategoryId } from '../../../utils/category-utils'

/**
 * Belge kategori metodlarını oluşturur
 *
 * @param {Object} state - Uygulama state
 * @param {Object} services - Servisler
 * @returns {Object} Belge kategori metodları
 */
export const createDocumentCategoryMethods = (state, services) => {
  const { files } = state

  const {
    assetStore,
    axios,
    settings,
    responseHandlerService,
  } = services

  /**
   * Belge kategorilerini güncelle
   *
   * @param {String} documentId - Güncellenecek belgenin ID'si
   * @param {Array} categoryIds - Atanacak kategori ID'leri
   * @param {String} documentAssetId - Belgenin ait olduğu asset ID (opsiyonel)
   */
  const handleUpdateCategories = async (documentId, categoryIds, documentAssetId) => {
    if (!documentId || !Array.isArray(categoryIds)) return

    try {
      // Ensure all category IDs are normalized
      const normalizedCategoryIds = categoryIds.map(id => normalizeCategoryId(id))

      // Use document's specific assetId if provided, otherwise use global assetId
      const assetIdToUse = documentAssetId || assetStore.assetId

      // Kategorileri güncelle
      await updateDocumentCategories({
        axios,
        settings,
        assetId: assetIdToUse,
        documentId,
        categoryIds: normalizedCategoryIds,
      })

      responseHandlerService.handleSuccess('Kategoriler başarıyla güncellendi')

      // Yenileme işlemi - bu metodu dışarıda ekleniyor, bağımlılık döngüsünü önlemek için
      // Yenileme işlemini çağıran/kullanıcı kodu üstleniyor
    } catch (error) {
      responseHandlerService.handleError(error, 'Kategoriler güncellenirken bir hata oluştu')
    }
  }

  /**
   * Dosya kategorilerini güncelle
   *
   * @param {String} fileId - Dosya ID'si
   * @param {Array} categoryIds - Kategori ID'leri
   */
  const updateFileCategories = (fileId, categoryIds) => {
    const fileIndex = files.value.findIndex(f => f.id === fileId)
    if (fileIndex !== -1) {
      files.value[fileIndex].categoryIds = categoryIds
    }
  }

  // Public API
  return {
    handleUpdateCategories,
    updateFileCategories,
  }
}